export const OneTimeRequest = 'oneTimeRequest';
export const VacancyRequest = 'vacancyRequest';

export const isOneTimeRequest = (requestType: string) =>
    requestType === OneTimeRequest;
export const isVacancyRequest = (requestType: string) =>
    requestType === VacancyRequest;

export const enum RequestTypeTabs {
    OneTimeRequests = 0,
    SpecialReserveRequests = 1,
    VacancyRequests = 2,
    RequestRegistrations = 3,
    Clocks = 4,
}

export const isOneTimeRequestTabSelected = (selectedTab: RequestTypeTabs) =>
    selectedTab === RequestTypeTabs.OneTimeRequests;
export const isSpecialReserveRequestTabSelected = (
    selectedTab: RequestTypeTabs,
) => selectedTab === RequestTypeTabs.SpecialReserveRequests;
export const isVacancyRequestTabSelected = (selectedTab: RequestTypeTabs) =>
    selectedTab === RequestTypeTabs.VacancyRequests;
export const isRequestRegistrationsTabSelected = (
    selectedTab: RequestTypeTabs,
) => selectedTab === RequestTypeTabs.RequestRegistrations;
export const isClocksTabSelected = (selectedTab: RequestTypeTabs) =>
    selectedTab === RequestTypeTabs.Clocks;

export const getRequestTypeFromTab = (tab: RequestTypeTabs) => {
    switch (tab) {
        case RequestTypeTabs.OneTimeRequests:
        case RequestTypeTabs.SpecialReserveRequests:
            return OneTimeRequest;
        case RequestTypeTabs.VacancyRequests:
            return VacancyRequest;
    }
};
